export const SkeletonLoader = () => (
  <div className="absolute inset-0 z-10 overflow-hidden bg-gray-100">
    <div className="h-full w-full p-4">
      <div className="flex flex-col space-y-4 motion-safe:animate-pulse motion-reduce:animate-none">
        <div className="h-32 w-full rounded bg-gray-200" />
        <div className="space-y-3">
          <div className="h-4 w-1/3 rounded bg-gray-200" />
        </div>
        <div className="h-12 w-full rounded bg-gray-200" />
        <div className="h-28 w-full rounded bg-gray-200" />
        <div className="h-16 w-full rounded bg-gray-200" />
        <div className="h-8 w-24 rounded bg-gray-200" />
        <div className="h-4 w-full rounded bg-gray-200" />
      </div>
    </div>
  </div>
);
